import { marker } from '@jsverse/transloco-keys-manager/marker';

export const SAVE_TIMEOUT_MS = 3 * 60 * 1000; // 3 minutes
export const SAVE_SUCCESS_CLOSE_DELAY_MS = 1500;

export const SAVE_PROGRESS_KEYS: readonly string[] = [
  marker('Mise à jour de la lésion ...'),
  marker('Enregistrement des données formulaires ...'),
  marker('Synchronisation des photos ...'),
  marker("Cela peut prendre jusqu'à quelques minutes, merci de patienter."),
  marker('Finalisation en cours ...'),
];

export const SAVE_SUCCESS_KEY = marker('Modifications enregistrées.');
export const SAVE_ERROR_KEY = marker("Une erreur est survenue lors de l'enregistrement.");
export const SAVE_INCOMPLETE_FORMS_KEY = marker(
  'Certains formulaires sont incomplets ou contiennent des réponses invalides.',
);
